<template>
  <div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="item" v-for="(item, index) in dataList" :key="index">
        <div class="top">
          <div>
            <span>企业名称：</span>
            <span>{{ item.companyName }}</span>
          </div>
          <div>
            <span>客户姓名：</span>
            <span>{{ item.name }}</span>
          </div>
          <div>
            <span>联系电话：</span>
            <span>{{ item.phone }}</span>
          </div>
          <div>
            <span>创建时间：</span>
            <span>{{ parseTime(item.createDateTime) }}</span>
          </div>
        </div>
        <div class="bottom">
          <div @click="toCall(item.phone)">
            <img
              src="https://static.xchengtech.cn/bc3a408f371f49db80b9193ed34bdfed.png"
              alt=""
            /><span>联系客户</span>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import {
  Button,
  RadioGroup,
  Radio,
  Toast,
  Notify,
  Picker,
  Form,
  Empty,
  List,
  Field,
  Dialog,
  Collapse,
  CollapseItem,
  Popover,
} from "vant";
Vue.use(Button);
Vue.use(RadioGroup);
Vue.use(Popover);
Vue.use(Radio);
Vue.use(Field);
Vue.use(Empty);
Vue.use(Toast);
Vue.use(Picker);
Vue.use(List);
Vue.use(Form);
Vue.use(Collapse);
Vue.use(CollapseItem);
import Vue from "vue";
import { parseTime } from "@/utils/index.js";
import { xcCzpt } from "@/api/xcCustomer";
export default {
  created() {},
  data() {
    return {
      query: {
        size: 10,
        page: 0,
        sort: "createDateTime,desc",
        createDateTime: [],
      },
      dataList: [],
      loading: false,
      finished: false,
      resourceTypeOptions: [
        {
          label: "分配",
          value: "allocation",
        },
        {
          label: "拓客",
          value: "development",
        },
        {
          label: "进件",
          value: "apply",
        },
      ],
      toApplyDialogShow: false,
    };
  },
  methods: {
    parseTime,
    onLoad() {
      this.loading = true;
      this.getXcCustomerData();
    },
    onSearch() {
      this.query.page = 0;
      this.finished = false;
      this.loading = true;
      this.dataList = [];
      this.getXcCustomerData();
    },
    // 获取订单数据
    getXcCustomerData() {
      if (!this.query.companyName) delete this.query.companyName;
      xcCzpt(this.query)
        .then((res) => {
          this.dataList = this.dataList.concat(res.content);
          this.loading = false;
          this.query.page++;
          console.log("dataList", this.dataList);
          if (res.content.length == 0) {
            this.finished = true;
          }
        })
        .catch((err) => {
          console.log("err", err);
          Toast.clear();
        });
    },
    toCall(item) {
      window.open("tel:" + item);
    },
  },
};
</script>

<style scoped>
.item {
  position: relative;
  padding: 2vw 4vw 3vw 4vw;
  background-color: #ffffff;
  margin-bottom: 5vw;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.item:nth-last-of-type(1) {
  margin-bottom: 0;
}
.item .top {
}
.item .top div {
  /* font-size: 3.6vw; */
  padding: 2vw 0;
  /* border-bottom: 1px solid #f4f4f4; */
}
.item .top div span:nth-of-type(1) {
  color: #667799;
}
.item .bottom {
  position: absolute;
  top: 4vw;
  right: 4vw;
  color: #838383;
}
.item .bottom div {
  display: flex;
  align-items: center;
  gap: 1vw;
  justify-content: center;
}
.item .bottom div img {
  display: block;
  width: 4vw;
}
</style>


// WEBPACK FOOTER //
// src/view/myCustomer/module/czbtData/index.vue